/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const JobCancelDetails = core.serialization.object({
    info: core.serialization.string().optional(),
});
